import { fetchConToken } from '../helpers/fetch';

const CertificadosService = {
    deleteFileCertificado : (idCertificadoFile) => {
        return fetchConToken(`CertificadosAfiliados/File/${idCertificadoFile}`, {}, 'DELETE')
    },
    deleteCertificado : (idCertificado) => {
        return fetchConToken(`CertificadosAfiliados/${idCertificado}`, {}, 'DELETE')
    },
    deleteFileCertificadoStage : (idCertificadoFile) => {
        return fetchConToken(`CertificadosAfiliadosStage/File/${idCertificadoFile}`, {}, 'DELETE')
    },
    deleteCertificadoStage : (idCertificado) => {
        return fetchConToken(`CertificadosAfiliadosStage/${idCertificado}`, {}, 'DELETE')
    }
}

export {CertificadosService as default}